/* eslint-disable no-underscore-dangle */
import { BaseModel } from '../models';

export default class BookmarkItem extends BaseModel {
  constructor(data = {}) {
    super({
      '@id': data.element,
    });

    this._element = data.element || null;
    this.name = data.name || null;
  }

  set element(value) {
    this._element = value.startsWith('U\'') ? value : `U'${value}'`;
  }

  get element() {
    return this._element;
  }
}
